import { createContext, useContext } from 'react';
import { TenantCode } from '../config';

interface TenantContextType {
    tenantCode: TenantCode;
}

export const TenantContext = createContext<TenantContextType | null>(null);

export const useTenant = () => {
    const context = useContext(TenantContext);
    if (!context) {
        throw new Error('useTenant must be used within a TenantProvider');
    }
    return context;
};
